import { Component, Inject, HostListener} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser'
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Logo } from '../../models/logo.model';
import { QuayBanCuaHang } from '../../models/store_stalls.model';
import { AuthenticationService } from '../../services/authentication.service';
import { UploadFileService } from '../../services/upload-file.service';
import { AppState } from '../../ngrx-store/app.state';
import { catChuoi } from '../../models/types';
import { BgColors } from '../../models/bg_color.model';
import { LocationStrategy } from '@angular/common';
import * as localForage from 'localforage';
import * as moment from 'moment';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SignInComponent {

  checkSignIn = false;
  _isPageTab = false;
  _isChecked = false;
  isFirstTime_LoadHelp = false;
  helppart = null;
  today: number = Date.now();
  logo: Logo = new Logo();
  dtStore: Observable<QuayBanCuaHang>;

  signInForm: FormGroup;
  viewContent: any;
  url: any;
  intervalTime = 1000;
  messageError = '';
  dtQBan: QuayBanCuaHang;
  colorBG: BgColors = new BgColors();
  catchuoi = catChuoi;
  constructor(
    private sanitizer: DomSanitizer,
    private locationStrategy: LocationStrategy,
    private fb: FormBuilder,
    private authenticationService: AuthenticationService,
    private http: HttpClient,
    private uploadFileService: UploadFileService,
    private store: Store<AppState>,
    @Inject('BASE_URL') baseUrl: string,
  ) {
    this.url = baseUrl + 'assets/images/Logo/';
    this.signInForm = this.fb.group({
      account: ['', Validators.required],
      password: ['', [ Validators.required ]]
    });

    this.dtStore = this.store.select(state => state.store);
    this.dtStore.subscribe(x => {
      if (x) {
        this.dtQBan = x[0];
        this.dtQBan.TenCH = catChuoi(this.dtQBan.TenCH, 30);
        console.log(this.dtQBan);
      } else {
        const getState: QuayBanCuaHang = JSON.parse(localStorage.getItem('_dtQBan'));
        if (getState) {
          console.log(getState[0]);
          this.dtQBan = getState[0];
          this.dtQBan.TenCH = catChuoi(this.dtQBan.TenCH, 30);
        }
      }
    });

    this.TPCloud_GetBGColor();
  }
  @HostListener('document:keydown', ['$event'])
  //@HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    //console.log(event.keyCode);
    switch (event.keyCode) {
      case 116:
        event.returnValue = false;
        return false;
      case 82:
        if (event.ctrlKey) {
          event.returnValue = false;
          return false;
        }   
    }
  }


  preventBackBtton() {
    history.pushState(null, null, location.href);
    this.locationStrategy.onPopState(() => {
      history.pushState(null, null, location.href);
    });
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit(): void {
    window.addEventListener('beforeunload', (event) => {
      return false;
    });
    this.preventBackBtton();
    setInterval(this.KiemTra_KetNoi, this.intervalTime);
    setInterval(() => {
      if (this.today !== Date.now()) {
        this.today = Date.now();
      } else {

      }
    }, 10000);
    this.uploadFileService.getFileName()
    .then((res: Logo) => {
      console.log(res);
      this.logo.lg_content = res.lg_content;
      this.logo.lg_overall = res.lg_overall;
      this.logo.lg_start = res.lg_start;
    });
  }
  submitCheckSignIn(message: string) {
    this.messageError = message;
    this.checkSignIn = !this.checkSignIn;
  }

  async onSignIn() {
    // Trí thêm phần để test
    const t = moment();
    const NgayLog = t.format('DDMMYYYY');
    const NgayBan = await localForage.getItem('_NgayBan');
    if (NgayLog != NgayBan) {
      localForage.setItem('_NgayBan', NgayLog);
      localForage.removeItem('_dsHD');
    }
    // Kết thúc phần Trí thêm phần để test
    const {account, password} = this.signInForm.value;
    this.authenticationService.login(account, password, this._isChecked)
    .catch(error => {
      this.submitCheckSignIn(error);
      this.signInForm.get('password').setValue('');
    });
  }

  public KiemTra_KetNoi() {
    const onl_flag = document.getElementsByClassName('online-flag') as HTMLCollectionOf<HTMLElement>;
    const off_flag = document.getElementsByClassName('offline-flag') as HTMLCollectionOf<HTMLElement>;
    if (window.navigator.onLine === true) {
      if (onl_flag.length !== 0) {
        onl_flag[0].style.opacity = '1';
      }
      if (off_flag.length !== 0) {
        off_flag[0].style.opacity = '0.2';
      }
    } else {
      if (onl_flag.length !== 0) {
        onl_flag[0].style.opacity = '0.2';
      }
      if (off_flag.length !== 0) {
        off_flag[0].style.opacity = '1';
        }
    }
  }

  async callPageHelp() {
    await this.LoadPageHelp()
    if (this._isPageTab !== true) {
      this.isFirstTime_LoadHelp = false;
    }
    else {
      this.isFirstTime_LoadHelp = true;
    }
  }


  async LoadPageHelp() {
    await this.http.get('assets/template/tabHelp.html', {responseType: 'text'}).subscribe(data => {
      this.viewContent = this.sanitizer.bypassSecurityTrustHtml(data);
      this.helppart = 'beginlogin'
    });
    this._isPageTab = !this._isPageTab;
  }

  loadtoanchor() {
    var el = document.getElementById(this.helppart);
    el.scrollIntoView({ behavior: "smooth" });
  }

  ngAfterViewChecked() {
    //this.scrollToBottom();
    if (this.isFirstTime_LoadHelp === true && this._isPageTab === true) {
      this.loadtoanchor();
      this.isFirstTime_LoadHelp = false;
    }
  }

  submitTroLaiBatDau() {
    this.authenticationService.out_to_quayban();
  }

  async TPCloud_GetBGColor() {
        // this.colorBG = JSON.parse(localStorage.getItem('_colorBG')); // còn sài, test thử cái dưới
        await localForage.getItem('_colorBG').then((result: any) => {
          console.log(JSON.parse(result));
          this.colorBG = JSON.parse(result);
        })
        .catch (err => {
          console.log('Lỗi');
        });
      }
}



// WEBPACK FOOTER //
// ./src/app/components/signin/signin.component.ts